import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@naf-simba/elements-buttons';
import { CraneCar } from '@naf-simba/building-blocks-icons/VehiclesAndElements';
import { ORDER_ROADSIDE_URL } from '@lib/constants';
import { useHandleNavigationClick } from '../../utils/Tracking/Navigation/NavigationTracking';

export const RoadsideAssistanceButton: React.FC = () => {
  const location = useLocation();
  const handleOnClick = useHandleNavigationClick({
    event: 'navbarMenuClick',
    menuPage: location.pathname,
    menuSectionName: 'highlightedLink',
    menuItemName: 'Bestill veihjelp',
    menuItemUrl: ORDER_ROADSIDE_URL,
  });

  return (
    <Button
      color="secondary"
      shade="light"
      startIcon={CraneCar}
      width="full"
      size="small"
      onClick={handleOnClick}
      href={ORDER_ROADSIDE_URL}
      target="_blank"
    >
      Bestill veihjelp
    </Button>
  );
};
